import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { formatRelativeTime } from "@/lib/freshness";
import type { useWorkRequests } from "./use-work-requests";

export function SupersedeRequestDialog({
  requests,
}: {
  requests: ReturnType<typeof useWorkRequests>;
}) {
  const pending = requests.pendingSupersede;
  return (
    <AlertDialog
      open={!!pending}
      onOpenChange={(open) => !open && requests.dismissSupersede()}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Re-queue this request?</AlertDialogTitle>
          <AlertDialogDescription>
            A request from{" "}
            {pending ? formatRelativeTime(pending.existing.requestedAt) : ""} is
            still open
            {pending?.existing.status === "claimed"
              ? ` and claimed by ${pending.existing.claimedBy ?? "an agent"}`
              : ""}
            . Re-queuing closes it and starts a new one.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Keep existing</AlertDialogCancel>
          <AlertDialogAction onClick={() => requests.confirmSupersede()}>
            Re-queue
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
